export const IG = 'https://www.instagram.com/duckybytes';
export const TIKTOK = 'https://www.tiktok.com/@duckybytes';
export const TWITCH = 'https://www.twitch.tv/duckybytes/profile';
